import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ApplicationMessagesWrapper from "../inAppMessages/ApplicationMessagesWrapper";
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import CLIENT from '../../utils/restClient';
import Logger, { ALL_MESSAGES, LOG_LEVELS } from '../../utils/logger';
import Modal from 'react-responsive-modal';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';
import { classifyMtdSubmissionResponse, MTD_SUBMIT_FILING_LOG_SCOPE } from '../../utils/mtdSubmissionResponse';

const log = new Logger(MTD_SUBMIT_FILING_LOG_SCOPE, LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES = {
  modal: 'modal-full-width',
};

// The submit endpoint returns a 400 with this exact message when the VAT number's HMRC authorization is missing or expired.
const HMRC_NOT_AUTHORIZED_ERROR = 'VAT Number is not authorized with HMRC';

const MTD_WARNING_MESSAGE_IDS = [
  ALL_MESSAGES.MTD_SUBMISSION_WARNING,
  ALL_MESSAGES.MTD_SUBMISSION_WARNING_WITH_ERROR
];

class MTDSubmitFiling extends Component {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, this.state, { isSubmitPopupOpen: false });
    this.fetchDocument = this.fetchDocument.bind(this);
  }

  fetchDocument() {
    CLIENT.getFilingDocumentAsText('TXT', this.props.uri)
      .then((response) => {
        log.debug('fetchDocument(): getFilingDocumentAsText got a response: ' + response);
        this.setState({
          loading: false,
          data: response,
          error: undefined,
        });
      })
      .catch((error) => {
        log.debug('fetchDocument(): getFilingDocumentAsText got an error: ', error);
        this.setState({
          loading: false,
          data: undefined,
          error: error,
        });
      });
    this.setState({
      loading: true,
      data: undefined,
      error: undefined,
    });
  }

  getStartDateFromFileName(fileName) {
    var index = fileName.indexOf('(');
    return fileName.substring(index + 1, index + 11);
  }

  getEndDateFromFileName(fileName) {
    var index = fileName.indexOf('_');
    return fileName.substring(index + 1, index + 11);
  }

  onOpenModal() {
    log.clearAllDictionaryErrors();
    this.setState({ isSubmitPopupOpen: true });
  }

  onCloseModal() {
    this.setState({ isSubmitPopupOpen: false });
  }

  onSubmitReport() {
    log.debug('onSubmitReport ', this.props);
    log.clearDictionaryError(ALL_MESSAGES.VAT_RETURN_SUBMISSION_FAILED);
    log.clearDictionaryError(ALL_MESSAGES.VAT_RETURN_SUBMISSION_AUTH_FAILED);
    // addError() never refreshes args, so a stale warning must be cleared before a new submit.
    MTD_WARNING_MESSAGE_IDS.forEach((messageId) => log.clearDictionaryError(messageId));

    this.setState({ isSubmitPopupOpen: false });
    
    CLIENT.getFilingDocumentAsText('JSON', this.props.uri)
      .then((response) => {
        const params = {
          startdate: this.getStartDateFromFileName(this.props.filename), //'2017-04-01',
          enddate: this.getEndDateFromFileName(this.props.filename), //'2017-06-30',
          vatnumber: this.props.vatnumber,
          companyCode: this.props.companyCode,
        };
        log.debug('fetchDocument(): getFilingDocumentAsText got a response: ' + response);
        CLIENT.submitUKMTDVATReport(response, params)
          .then((response) => {
            log.debug('submitUKMTDVATReport got an success: ', response);
            const { warning } = classifyMtdSubmissionResponse(response);
            // Must be set BEFORE onApprove(): onApprove() unmounts this component in both
            // flows (sync -> uri becomes ''; async -> showVatReturnGenerationControls false),
            // so the banner is rendered by FilingPreparation, not here. Redux dispatch is
            // synchronous, so the message is in the store before the unmount.
            if (warning) {
              log.setDictionaryMessage(ALL_MESSAGES.MTD_SUBMISSION_WARNING, warning);
            }
            //on success call approve report
            if (this.props !== undefined && typeof this.props.onApprove === 'function') this.props.onApprove();
          })
          .catch((error) => {
            log.debug('submitUKMTDVATReport got an error: ', error);
            if (error && error.warning) {
              log.setDictionaryMessage(ALL_MESSAGES.MTD_SUBMISSION_WARNING_WITH_ERROR, error.warning);
            }
            if (error && error.message) {
              if (error.message.indexOf(HMRC_NOT_AUTHORIZED_ERROR) >= 0) {
                log.setDictionaryMessage(ALL_MESSAGES.VAT_RETURN_SUBMISSION_AUTH_FAILED);
              } else {
                log.setDictionaryMessage(ALL_MESSAGES.VAT_RETURN_SUBMISSION_FAILED, error.message);
              }
            }
          });
      })
      .catch((error) => {
        log.debug('fetchDocument(): getFilingDocumentAsText got an error: ', error);
      });
  }

  render() {
    log.debug('render(): ', this.props);

    const originalData = String(this.state.data);
    const removeSpeechMarks = originalData.replace(/"/g, '');
    const splitData = removeSpeechMarks.split(',');
    const boxDescription = [
      'submitFiling_Box1',
      'submitFiling_Box2',
      'submitFiling_Box3',
      'submitFiling_Box4',
      'submitFiling_Box5',
      'submitFiling_Box6',
      'submitFiling_Box7',
      'submitFiling_Box8',
      'submitFiling_Box9',
    ];
    const boxValues = (
      <table>
        <tbody>
          {splitData.slice(1, -1).map((value, index) => {
            let [, amount] = value.split(':');
            return (
              <tr key={value}>
                <td>
                  <LanguageStringResolver string="submitFiling_Box" /> {index + 1}
                </td>
                <td className={withFullStoryExclude()}>£{amount}</td>
                <td>{<LanguageStringResolver string={boxDescription[index]} />}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );

    return (
      <>
        <ApplicationMessagesWrapper
          messageIds={[ ALL_MESSAGES.VAT_RETURN_SUBMISSION_FAILED ]}
          messageType="applicationError"
        />
        <ApplicationMessagesWrapper
          messageIds={[ ALL_MESSAGES.VAT_RETURN_SUBMISSION_AUTH_FAILED ]}
          messageType="applicationError"
        >
          <span>
            {' '}
            {this.props.companyId !== undefined && this.props.companyId !== null && this.props.vatnumber ? (
              <Link
                to={`/companies?companyId=${encodeURIComponent(this.props.companyId)}&vatNumber=${encodeURIComponent(this.props.vatnumber)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <LanguageStringResolver string="filingPage_HMRCAuthFailedLinkText" />
              </Link>
            ) : (
              <LanguageStringResolver string="filingPage_HMRCAuthFailedNoLinkText" />
            )}
            .
          </span>
        </ApplicationMessagesWrapper>
        <ApplicationMessagesWrapper
          messageIds={[ ALL_MESSAGES.MTD_SUBMISSION_WARNING_WITH_ERROR ]}
          messageType="applicationWarning"
        />
        <ReadOnlyWrapper>
          <button className="primary mb20" onClick={() => this.onOpenModal()}>
            <LanguageStringResolver string="filingPage_SubmitVATBtn" />
          </button>
        </ReadOnlyWrapper>
        <Modal center classNames={MODAL_CLASSNAMES} open={this.state.isSubmitPopupOpen} onClose={() => this.onCloseModal()}>
          <div>
            <h1>
              <LanguageStringResolver string="submitFiling_ConfirmBoxValuesTitle" />
            </h1>
            {boxValues}
            <p className="mt20">
              <LanguageStringResolver string="submitFiling_Disclaimer" />
            </p>
            <p className="mb20">
              <LanguageStringResolver string="submitFiling_warning" />
            </p>
            <p className="mb20 bold">
              <LanguageStringResolver string="submitFiling_MTD_Warning" />
            </p>
            <a className="button primary" onClick={this.onSubmitReport.bind(this)}>
              <LanguageStringResolver string="submitFiling_ok" />
            </a>
            <a className="button secondary" onClick={() => this.onCloseModal()}>
              <LanguageStringResolver string="submitFiling_cancel" />
            </a>
          </div>
        </Modal>
      </>
    );
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.fetchDocument();
  }

  componentDidUpdate(prevProps) {
    log.debug('componentDidUpdate()');
    if (this.props.uri !== prevProps.uri) {
      this.fetchDocument();
    }
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  return {};
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(MTDSubmitFiling);
